import React, { useEffect, useState, useContext } from 'react'
import icon__close from '../../../asset/icon/close-icon.svg'

import Input from '../input/Input'

import { CurrentUserContext } from '../../../App'

import * as publicApi from '../../../service/publicApi'

import { HashLoader } from 'react-spinners'

function ModalAlertLabData({
    title,
    detail,
    onClose,
    limitSizeHeight,
    limitSizeWeight,
    disabledIconX,
    statusFindData,
    inputValue
}) {

    const {
        setIsMessage
    } = useContext(CurrentUserContext);

    const [loading, setLoading] = useState(false)

    const [stepNextContent, setStepNextContent] = useState(1)
    const [formState, setFormState] = useState({
        pid: inputValue,
        fname: "",
        lname: "",
        phone_number: "",
        hospital_name: ""
    })


    useEffect(() => {

    }, [])

    // console.log(statusFindData)


    async function addPetition() {
        setLoading(true)
        let res = await publicApi.addPetition(formState)
        setLoading(false)

        if (res) {
            if (res['data']['code'] === 200) {
                setStepNextContent(3)
            } else {
                setIsMessage({ type: 'warning', data: res['data']['message_th'] || res['data']['message']})
            }
        } else {
            setIsMessage({ type: 'error', data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่"})
        }
    }

    const handleChangeFormState = (e) => {
        setFormState({
            ...formState, [e.target.name]: e.target.value
        })
    }

    const handleSubmitReportPetition = () => {

        if (!formState.fname) {
            return setIsMessage({type: 'warning', data:  'กรุณาระบุชื่อ'})
        }
        if (!formState.lname) {
            return setIsMessage({type: 'warning', data:'กรุณาระบุนามสกุล'})
        }
        if (!formState.pid) {
            return setIsMessage({type: 'warning', data:'กรุณาระบุเลขประจำตัวประชาชน'})
        }
        if (!formState.hospital_name) {
            return setIsMessage({type: 'warning', data:'กรุณาระบุชื่อโรงพยาบาล'})
        }
        if (!formState.phone_number) {
            return setIsMessage({type: 'warning', data:'กรุณาระบุเบอร์ติดต่อ'})
        }

        addPetition()
    }

    // console.log(statusFindData)
    // console.log(detail)

    return (
        <div className='fixed w-full h-full z-20 inset-0 flex justify-center items-center bg-[#0000008f]'>
            <HashLoader loading={loading} style={{ display: 'flex', justifyContent: 'center' }} color="#FF9768" />
            {
                stepNextContent === 1 ? <>
                    <div className={`${limitSizeHeight ? limitSizeHeight : 'md:w-[300px] w-[500px]'} ${limitSizeHeight ? limitSizeHeight : 'md:h-[200px] h-[300px]'} bg-[#FFFFFF] rounded-3xl`}>
                        {
                            disabledIconX ? null :
                                <div className="relative">
                                    <div className='absolute top-3 right-0'>
                                        <img onClick={() => { onClose() }} className='w-[30px] h-[30px] mr-[30px] hover:cursor-pointer' src={icon__close} alt='' />
                                    </div>
                                </div>
                        }
                        <div className='md:text-[14px] text-center font-bold text-[#000000] md:my-[10px] my-5'>{title}</div>
                        <div className='border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768] md:my-[5px] my-[25px]'></div>
                        <div className='md:my-[25px] my-[60px] flex justify-center items-center'>
                            <div className='md:text-[12px] text-xl text-center text-[#000000]'>{detail}</div>
                        </div>
                        {
                            statusFindData === 'HAVE DATA' ? <div className='flex justify-center items-center'>
                                <button onClick={() => { onClose() }} className='button-theme-pg flex justify-center items-center w-32 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 shadow-sm shadow-brand-cyan '>
                                    เข้าใจแล้ว
                                </button>
                            </div> : <div className='md:my-[25px] my-[60px] flex justify-center items-center'>
                                <div onClick={() => {
                                    setStepNextContent(stepNextContent + 1)
                                }} className='md:text-[12px] text-xl text-center text-[#FF9768] font-bold'>
                                    คลิกที่นี่ หากท่านคิดว่าเคยตรวจทางเภสัชพันธุศาสตร์
                                </div>
                            </div>
                        }
                    </div>
                </> : null
            }
            {
                stepNextContent === 2 ? <>
                    <div className={'md:h-[400px] w-[500px] h-[500px] bg-[#FFFFFF] rounded-3xl'}>
                        {
                            disabledIconX ? null :
                                <div className="relative">
                                    <div className='absolute top-3 right-0'>
                                        <img onClick={() => { onClose() }} className='w-[30px] h-[30px] mr-[30px] hover:cursor-pointer' src={icon__close} alt='' />
                                    </div>
                                </div>
                        }
                        <div className='md:text-[14px] text-center font-bold text-[#000000] md:my-[10px] my-5'>ส่งข้อมูลเพื่อตรวจสอบ</div>
                        <div className='border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768] md:my-[5px] my-[25px]'></div>
                        <div className='md:my-[25px] md:mx-[1rem] grid gap-3 my-[30px] mx-[5rem]'>

                            <Input
                                placeholder='ชื่อ'
                                disabledLabel
                                validate={formState.fname ? false : true}
                                name={'fname'}
                                value={formState.fname}
                                onChangeEvt={(e) => {
                                    handleChangeFormState(e)
                                }}
                            />

                            <Input
                                placeholder='นามสกุล'
                                disabledLabel
                                validate={formState.lname ? false : true}
                                name={'lname'}
                                value={formState.lname}
                                onChangeEvt={(e) => {
                                    handleChangeFormState(e)
                                }}
                            />

                            <Input
                                placeholder='เลขประจำตัวประชาชน'
                                disabledLabel
                                validate={formState.pid ? false : true}
                                name={'pid'}
                                maxLength={13} 
                                value={formState.pid}
                                onChangeEvt={(e) => {
                                    handleChangeFormState(e)
                                }}
                            />

                            <Input
                                placeholder='ชื่อโรงพยาบาล'
                                disabledLabel
                                validate={formState.hospital_name ? false : true}
                                name={'hospital_name'}
                                value={formState.hospital_name}
                                onChangeEvt={(e) => {
                                    handleChangeFormState(e)
                                }}
                            />

                            <Input
                                placeholder='เบอร์ติดต่อ'
                                disabledLabel
                                validate={formState.phone_number ? false : true}
                                name={'phone_number'}
                                value={formState.phone_number}
                                onChangeEvt={(e) => {
                                    handleChangeFormState(e)
                                }}
                                maxLength={10}
                            />

                        </div>
                        <div className='flex justify-center items-center'>
                            <button onClick={() => { handleSubmitReportPetition() }} className='button-theme-pg flex justify-center items-center w-[50%] md:w-[67%] md:h-[45px] h-[55px] bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 shadow-sm shadow-brand-cyan '>
                                ส่งข้อมูลไปยังผู้ดูแลระบบ
                            </button>
                        </div>
                    </div>

                </> : null
            }
            {
                stepNextContent === 3 ? <>
                    <div className={`${limitSizeHeight ? limitSizeHeight : 'md:w-[300px] w-[500px]'} ${limitSizeHeight ? limitSizeHeight : 'md:h-[150px] h-[240px]'} bg-[#FFFFFF] rounded-3xl`}>
                        
                        <div className='h-full flex flex-col gap-10 md:gap-2 justify-center items-center'>

                            <div className='md:text-[12px] text-xl text-center text-[#000000]'>กรุณารอการติดต่อกลับจากเจ้าหน้าที่</div>
                            <button onClick={() => { onClose() }} className='button-theme-pg flex justify-center items-center w-[169px] md:w-[120px] md:h-[30px] h-[45px] bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 shadow-sm shadow-brand-cyan '>
                                เข้าใจแล้ว
                            </button>
                        </div>
                    </div>
                </> : null
            }
        </div>
    )
}

export default ModalAlertLabData